import {
  ACTION_ASK_UNSUSPEND__REQUEST,
  ACTION_ASK_UNSUSPEND__SUCCESS,
  ACTION_ASK_UNSUSPEND__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_ASK_UNSUSPEND__REQUEST:
    case ACTION_ASK_UNSUSPEND__SUCCESS:
      return null;

    case ACTION_ASK_UNSUSPEND__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
